<template>
    <div class="page dashboard transactions-dashboard">
        <div class="content">
            <div class="title-bar">
                <p class="title">Setting, Homepage Product</p>
				<div class="group">
					<div class="btn new">
						<div class="icon"></div>
                        <router-link
                            :to="`/setting/edit-home-page-product`"
                            class="label"
                        >
						    Add New
                        </router-link>
					</div>
				</div>
            </div>
            <ListingComponent model="data" :data="{data:data,pageMeta: {page: 1, size: data.length, totalEntries: data.length, totalPages: 1}}" :query.sync="query"
                :refresh="getData" :toggleActionMenu="handleDataClick" :listingOptions="listingOptions"
                :deleteRecord="deleteData" :isLoading="false"/>
        </div>
    </div>
</template>

<script>
    import ListingLoadingComponent from "../../components/ListingLoadingComponent";
    import ListingComponent from "../../components/ListingComponent";
    import Searchbar from '../../components/Searchbar';

    export default {
        name: "SettingHomePageDashboard",
        components: {
            ListingLoadingComponent,
            ListingComponent,
            Searchbar,
        },
        data: function () {
            return {
                query: {
                    order: "ASC",
                    page: 1,
                    limit: 10,
                    sortBy: "",
                    status: 0,
                }
            };
        },
        created() {
            this.getData();
        },
        methods: {
            handleDataClick(action, payload) {
                if(action == 'edit') {
                    this.$router.push({ path: "/setting/edit-home-page-product", query: payload });
                }
            },
            getData() {
                this.$store.dispatch("getSettingDefaultHomePageProduct", {});
            },
            deleteData(item) {
                const confirmed = confirm('Are you sure you want to delete this?')
                
                if(confirmed) {
                    this.$store.dispatch("deleteSettingDefaultHomePageProduct", {
                        _id: item._id
                    });
                }
            },
        },
        watch: {
            query: {
                deep: true,
                handler: function () {
                    if (this.query.page >= 1) {
                        this.getData();
                    }
                },
            }
        },
        computed: {
            data() {
                return this.$store.state.setting.data || [];
            },
            listingOptions() {
                return {
                    hasSelected: false,
                    hasNo: true,
                    actions: ['delete', 'edit'],
                    queryOptions: {
                        sortBy: [],
                        sortDirection: [],
                    },
                    schema: [
                        {
                            label: "Title",
                            key: 'title'
                        },
                        {
                            label: "Order",
                            key: 'order'
                        },
                        {
                            label: "Search",
                            key: 'search'
                        },
                        {
                            label: "Limit",
                            key: 'pageSize'
                        },
                        {
                            label: "Start Price",
                            key: 'start_price'
                        },
                        {
                            label: "End Price",
                            key: 'end_price'
                        }
                    ],
                };
            }
        },
    };
</script>

<style></style>